import CancellationDueDeathPage from 'cancellations/pages/cancellation-due-death/cancellation';
import CancellationDueDeathSearchPersonPage from 'cancellations/pages/cancellation-due-death/search';
import HomePage from 'cancellations/pages/home';
import { Outlet } from 'react-router-dom';
import {
  CancellationsAuthorizationsList,
  CancellationDeathAuthorizations,
  CancellationAireAuthorizations,
} from 'shell/authorizations/cancellations';
import CardModule from './card-module';
import WrapperPersonSearch from 'shell/components/shared/person-search/wrapper-person-search';
import { NotFound } from 'shell/error/components/error-not-found';
import PageResearchNotificationsInitizializer from 'shell/components/shared/research-notifications';
import ResearchFamilyNotificationsPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-family/family';
import ResearchFamilyNotificationsDetailPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-family/family/detail';
import ResearchFamilyNotificationsMotherPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-family/mother';
import ResearchFamilyNotificationsMotherDetailPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-family/mother/detail';
import ResearchFamilyNotificationsFatherPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-family/father';
import ResearchFamilyNotificationsFatherDetailPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-family/father/detail';
import ResearchFamilyNotificationsOtherPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-family/other';
import ResearchFamilyNotificationsOtherDetailPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-family/other/detail';
import ResearchCohabitationNotificationsPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-cohabitation';
import ResearchCohabitationNotificationsDetailPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-cohabitation/detail';
import ResearchDeathNotificationsPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-death';
import CancellationDeathNotificationPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-death/detail';
import ResearchMarriageNotificationsPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-marriage';
import ResearchMarriageDetailNotificationsPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-marriage/detail';
import PersonSipoPage from 'cancellations/pages/edit-person';
import SearchPersonSipoPage from 'cancellations/pages/cancellation-non-resident/search';
import CancellationNonResidentPage from 'cancellations/pages/cancellation-non-resident/cancellation';
import ResearchMarriageNonResidentNotificationsPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-marriage-non-resident';
import ResearchMarriageNonResidentDetailNotificationsPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-marriage-non-resident/detail';
import PersonMarriageNonResidentNotificationsPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-marriage-non-resident/edit-person';
import PersonSearchMarriageNonResidentNotificationsPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-marriage-non-resident/edit-person-search';
import ResearchDeathNonResidentNotificationsPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-death-non-resident';
import ResearchDeathNonResidentDetailNotificationsPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-death-non-resident/detail';
import PersonSearchDeathNonResidentNotificationsPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-death-non-resident/edit-person-search';
import ResearchNotificationsCivilStatusRegistryOfficePage from 'cancellations/pages/research-registration-civil-status-registry-office/list';
import DetailNotificationsCivilStatusPage from 'cancellations/pages/research-registration-civil-status-registry-office/detail';
import EditNotificationsCivilStatusPage from 'cancellations/pages/research-registration-civil-status-registry-office/edit';
import ResearchBirthNonResidentNotificationsCivilStatusPage from 'cancellations/pages/research-registration-civil-status-registry-office/reasearch-birth-non-resident';
import ResearchCivilUnionNotificationCivilStatusPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-civil-union';
import RegistrationCivilUnionDetailNotificationsPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-civil-union/detail';
import ResearchCivilUnionNonResidentNotificationCivilStatusPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-civil-union-non-resident';
import PersonSearchCivilUnionNonResidentNotificationCivilStatusPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-civil-union-non-resident/edit-person-search';
import RegistrationCivilUnionDetailNotificationsCivilStatusPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-civil-union-non-resident/detail';
import PersonCivilUnionNonResidentNotificationCivilStatusPage from 'cancellations/pages/research-registration-civil-status-registry-office/research-civil-union-non-resident/edit-person';
import AnscNotificationsBirthNonResidentPage from 'cancellations/pages/ansc-notification/birth-non-resident';
import ResearchFamilyNotificationsCivilStatusPage from 'cancellations/pages/ansc-notification/research-family/family';
import ResearchFamilyNotificationsFatherDetailCivilStatusPage from 'cancellations/pages/ansc-notification/research-family/father/detail';
import ResearchFamilyNotificationsMotherCivilStatusPage from 'cancellations/pages/ansc-notification/research-family/mother';
import ResearchFamilyNotificationsDetailCivilStatusPage from 'cancellations/pages/ansc-notification/research-family/family/detail';
import ResearchFamilyNotificationsMotherDetailCivilStatusPage from 'cancellations/pages/ansc-notification/research-family/mother/detail';
import ResearchFamilyNotificationsFatherCivilStatusPage from 'cancellations/pages/ansc-notification/research-family/father';
import ResearchFamilyNotificationsOtherCivilStatusPage from 'cancellations/pages/ansc-notification/research-family/other';
import ResearchFamilyNotificationsOtherDetailCivilStatusPage from 'cancellations/pages/ansc-notification/research-family/other/detail';
import ResearchCohabitationNotificationCivilStatusPage from 'cancellations/pages/ansc-notification/research-cohabitation';
import RegisterCohabitationNotificationCivilStatusPage from 'cancellations/pages/ansc-notification/research-cohabitation/detail';
import ResearchDeathNotificationResidentCivilStatusPage from 'cancellations/pages/ansc-notification/research-death';
import CancellationDeathNotificationCivilStatusPage from 'cancellations/pages/ansc-notification/research-death/detail';
import ResearchDeathNonResidentNotificationCivilStatusPage from 'cancellations/pages/ansc-notification/research-death-non-resident';
import PersonSearchDeathNonResidentNotificationCivilStatusPage from 'cancellations/pages/ansc-notification/research-death-non-resident/edit-person-search';
import CancellationNonResidentNotificationCivilStatusPage from 'cancellations/pages/ansc-notification/research-death-non-resident/detail';
import ResearchMarriageNotificationsCivilStatusPage from 'cancellations/pages/ansc-notification/research-marriage';
import ResearchMarriageDetailNotificationsCivilStatusPage from 'cancellations/pages/ansc-notification/research-marriage/detail';
import ResearchMarriageNonResidentNotificationsCivilStatusPage from 'cancellations/pages/ansc-notification/research-marriage-non-resident';
import PersonSearchMarriageNonResidentNotificationsCivilStatusPage from 'cancellations/pages/ansc-notification/research-marriage-non-resident/edit-person-search';
import ResearchMarriageNonResidentDetailNotificationsCivilStatusPage from 'cancellations/pages/ansc-notification/research-marriage-non-resident/detail';
import PersonMarriageNonResidentNotificationsCivilStatusPage from 'cancellations/pages/ansc-notification/research-marriage-non-resident/edit-person';
import ResearchCivilUnionAnscNotificationCivilStatusPage from 'cancellations/pages/ansc-notification/research-civil-union';
import RegistrationCivilUnionDetailAnscNotificationPage from 'cancellations/pages/ansc-notification/research-civil-union/detail';
import ResearchCivilUnionNonResidentAnscNotificationNotificationCivilStatusPage from 'cancellations/pages/ansc-notification/research-civil-union-non-resident';
import PersonSearchCivilUnionNonResidentAnscNotificationCivilStatusPage from 'cancellations/pages/ansc-notification/research-civil-union-non-resident/edit-person-search';
import RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusPage from 'cancellations/pages/ansc-notification/research-civil-union-non-resident/detail';
import PersonCivilUnionNonResidentAnscNotificationCivilStatusPage from 'cancellations/pages/ansc-notification/research-civil-union-non-resident/edit-person';
import AnscNotificationsPage from 'cancellations/pages/ansc-notification/list';
import AnscNotificationsDetailPage from 'cancellations/pages/ansc-notification/detail';
import AnscNotificationsEditPage from 'cancellations/pages/ansc-notification/edit';
import ResearchCitizenshipAnscNotificationsPage from 'cancellations/pages/ansc-notification/research-citizenship';
import RegistrationCitizenshipAnscNotificationsPage from 'cancellations/pages/ansc-notification/research-citizenship/detail';
import CancellationUnderagePage from 'cancellations/pages/cancellation-underage/cancellation';
import SearchCancellationUnderagePersonSipoPage from 'cancellations/pages/cancellation-underage/search';

export const cancellationRoutes = [
  {
    path: '',
    element: <WrapperPersonSearch />,
    children: [
      {
        path: '/',
        name: '',
        hidden: true,
        authorizations: CancellationsAuthorizationsList,
        element: <HomePage />,
      },
      {
        path: '/cancellazione-per-morte',
        name: 'Cancellazione per Morte',
        authorizations: CancellationDeathAuthorizations,
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <CancellationDueDeathSearchPersonPage />,
          },
          {
            path: '/cancellazione',
            element: <CancellationDueDeathPage />,
          },
        ],
      },
      {
        path: '/minori',
        name: 'Cancellazione Minori',
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <SearchCancellationUnderagePersonSipoPage />,
          },
          {
            path: '/operazione',
            element: <CancellationUnderagePage />,
          },
        ],
      },
      {
        path: '/non-residenti',
        name: 'Cancellazione Non Residenti',
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <SearchPersonSipoPage />,
          },
          {
            path: '/operazione',
            element: <CancellationNonResidentPage />,
          },
          {
            path: '/persona-sipo',
            element: <PersonSipoPage />,
          },
        ],
      },
      {
        path: '/notifiche-da-stato-civile',
        element: <PageResearchNotificationsInitizializer />,
        children: [
          {
            path: '',
            element: <ResearchNotificationsCivilStatusRegistryOfficePage />,
          },
          {
            path: '/visualizza/:id/:idNotifica',
            element: <DetailNotificationsCivilStatusPage />,
          },
          {
            path: '/modifica/:id/:idNotifica',
            element: <Outlet />,
            children: [
              {
                path: '',
                element: <EditNotificationsCivilStatusPage />,
              },
              {
                path: '/nascita',
                element: <Outlet />,
                children: [
                  {
                    path: '/non-residenti',
                    element: <ResearchBirthNonResidentNotificationsCivilStatusPage />,
                  },
                ],
              },
              {
                path: '/famiglia',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchFamilyNotificationsPage />,
                  },
                  {
                    path: '/dettaglio',
                    element: <ResearchFamilyNotificationsDetailPage />,
                  },
                ],
              },
              {
                path: '/famiglia/madre',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchFamilyNotificationsMotherPage />,
                  },
                  {
                    path: '/dettaglio',
                    element: <ResearchFamilyNotificationsMotherDetailPage />,
                  },
                ],
              },
              {
                path: '/famiglia/padre',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchFamilyNotificationsFatherPage />,
                  },
                  {
                    path: '/dettaglio',
                    element: <ResearchFamilyNotificationsFatherDetailPage />,
                  },
                ],
              },
              {
                path: '/famiglia',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchFamilyNotificationsOtherPage />,
                  },
                  {
                    path: '/dettaglio',
                    element: <ResearchFamilyNotificationsOtherDetailPage />,
                  },
                ],
              },
              {
                path: '/convivenza',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchCohabitationNotificationsPage />,
                  },
                  {
                    path: '/nascita',
                    element: <ResearchCohabitationNotificationsDetailPage />,
                  },
                ],
              },
              {
                path: '/morte',
                element: <Outlet />,
                children: [
                  {
                    path: '/residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchDeathNotificationsPage />,
                      },
                      {
                        path: '/cancellazione',
                        element: <CancellationDeathNotificationPage />,
                      },
                    ],
                  },
                  {
                    path: '/non-residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchDeathNonResidentNotificationsPage />,
                      },
                      {
                        path: '/persona-sipo',
                        element: <PersonSearchDeathNonResidentNotificationsPage />,
                      },
                      {
                        path: '/cancellazione/:idIntestatario/:idSchedaSoggettoANPR',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchDeathNonResidentDetailNotificationsPage />,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                path: '/matrimonio',
                element: <Outlet />,
                children: [
                  {
                    path: '/residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchMarriageNotificationsPage />,
                      },
                      {
                        path: '/registrazione',
                        element: <ResearchMarriageDetailNotificationsPage />,
                      },
                    ],
                  },
                  {
                    path: '/non-residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchMarriageNonResidentNotificationsPage />,
                      },
                      {
                        path: '/persona-sipo',
                        element: <PersonSearchMarriageNonResidentNotificationsPage />,
                      },
                      {
                        path: '/registrazione/:idIntestatario/:idSchedaSoggettoANPR',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchMarriageNonResidentDetailNotificationsPage />,
                          },
                          {
                            path: '/persona-sipo',
                            element: <PersonMarriageNonResidentNotificationsPage />,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                path: '/unione-civile',
                element: <Outlet />,
                children: [
                  {
                    path: '/residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchCivilUnionNotificationCivilStatusPage />,
                      },
                      {
                        path: '/registrazione',
                        element: <RegistrationCivilUnionDetailNotificationsPage />,
                      },
                    ],
                  },
                  {
                    path: '/non-residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchCivilUnionNonResidentNotificationCivilStatusPage />,
                      },
                      {
                        path: '/persona-sipo',
                        element: <PersonSearchCivilUnionNonResidentNotificationCivilStatusPage />,
                      },
                      {
                        path: '/registrazione/:idIntestatario/:idSchedaSoggettoANPR',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <RegistrationCivilUnionDetailNotificationsCivilStatusPage />,
                          },
                          {
                            path: '/persona-sipo',
                            element: <PersonCivilUnionNonResidentNotificationCivilStatusPage />,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: '/notifiche',
        element: <Outlet />,
        children: [
          {
            path: '/ansc',
            element: <PageResearchNotificationsInitizializer />,
            children: [
              {
                path: '',
                element: <AnscNotificationsPage />,
              },
              {
                path: '/visualizza/:id/:idNotifica',
                element: <AnscNotificationsDetailPage />,
              },
              {
                path: '/modifica/:id/:idNotifica',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <AnscNotificationsEditPage />,
                  },
                  {
                    path: '/cittadinanza/ricerca',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchCitizenshipAnscNotificationsPage />,
                      },
                      {
                        path: '/registrazione',
                        element: <RegistrationCitizenshipAnscNotificationsPage />,
                      },
                    ],
                  },
                  {
                    path: '/nascita',
                    element: <Outlet />,
                    children: [
                      {
                        path: '/non-residenti',
                        element: <AnscNotificationsBirthNonResidentPage />,
                      },
                    ],
                  },
                  {
                    path: '/famiglia',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchFamilyNotificationsCivilStatusPage />,
                      },
                      {
                        path: '/dettaglio',
                        element: <ResearchFamilyNotificationsDetailCivilStatusPage />,
                      },
                    ],
                  },
                  {
                    path: '/famiglia/madre',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchFamilyNotificationsMotherCivilStatusPage />,
                      },
                      {
                        path: '/dettaglio',
                        element: <ResearchFamilyNotificationsMotherDetailCivilStatusPage />,
                      },
                    ],
                  },
                  {
                    path: '/famiglia/padre',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchFamilyNotificationsFatherCivilStatusPage />,
                      },
                      {
                        path: '/dettaglio',
                        element: <ResearchFamilyNotificationsFatherDetailCivilStatusPage />,
                      },
                    ],
                  },
                  {
                    path: '/famiglia/altra',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchFamilyNotificationsOtherCivilStatusPage />,
                      },
                      {
                        path: '/dettaglio',
                        element: <ResearchFamilyNotificationsOtherDetailCivilStatusPage />,
                      },
                    ],
                  },
                  {
                    path: '/convivenza',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchCohabitationNotificationCivilStatusPage />,
                      },
                      {
                        path: '/nascita',
                        element: <RegisterCohabitationNotificationCivilStatusPage />,
                      },
                    ],
                  },
                  {
                    path: '/morte',
                    element: <Outlet />,
                    children: [
                      {
                        path: '/residenti',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchDeathNotificationResidentCivilStatusPage />,
                          },
                          {
                            path: '/cancellazione',
                            element: <CancellationDeathNotificationCivilStatusPage />,
                          },
                        ],
                      },
                      {
                        path: '/non-residenti',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchDeathNonResidentNotificationCivilStatusPage />,
                          },
                          {
                            path: '/persona-sipo',
                            element: <PersonSearchDeathNonResidentNotificationCivilStatusPage />,
                          },
                          {
                            path: '/cancellazione/:idIntestatario/:idSchedaSoggettoANPR',
                            element: <Outlet />,
                            children: [
                              {
                                path: '',
                                element: <CancellationNonResidentNotificationCivilStatusPage />,
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: '/matrimonio',
                    element: <Outlet />,
                    children: [
                      {
                        path: '/residenti',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchMarriageNotificationsCivilStatusPage />,
                          },
                          {
                            path: '/registrazione',
                            element: <ResearchMarriageDetailNotificationsCivilStatusPage />,
                          },
                        ],
                      },
                      {
                        path: '/non-residenti',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchMarriageNonResidentNotificationsCivilStatusPage />,
                          },
                          {
                            path: '/persona-sipo',
                            element: (
                              <PersonSearchMarriageNonResidentNotificationsCivilStatusPage />
                            ),
                          },
                          {
                            path: '/registrazione/:idIntestatario/:idSchedaSoggettoANPR',
                            element: <Outlet />,
                            children: [
                              {
                                path: '',
                                element: (
                                  <ResearchMarriageNonResidentDetailNotificationsCivilStatusPage />
                                ),
                              },
                              {
                                path: '/persona-sipo',
                                element: <PersonMarriageNonResidentNotificationsCivilStatusPage />,
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: '/unione-civile',
                    element: <Outlet />,
                    children: [
                      {
                        path: '/residenti',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchCivilUnionAnscNotificationCivilStatusPage />,
                          },
                          {
                            path: '/registrazione',
                            element: <RegistrationCivilUnionDetailAnscNotificationPage />,
                          },
                        ],
                      },
                      {
                        path: '/non-residenti',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: (
                              <ResearchCivilUnionNonResidentAnscNotificationNotificationCivilStatusPage />
                            ),
                          },
                          {
                            path: '/persona-sipo',
                            element: (
                              <PersonSearchCivilUnionNonResidentAnscNotificationCivilStatusPage />
                            ),
                          },
                          {
                            path: '/registrazione/:idIntestatario/:idSchedaSoggettoANPR',
                            element: <Outlet />,
                            children: [
                              {
                                path: '',
                                element: (
                                  <RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusPage />
                                ),
                              },
                              {
                                path: '/persona-sipo',
                                element: (
                                  <PersonCivilUnionNonResidentAnscNotificationCivilStatusPage />
                                ),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: '*',
        element: <CardModule />,
        authorizations: [...CancellationAireAuthorizations],
        hidden: true,
      },
      {
        element: <NotFound />,
        path: '*',
        hidden: true,
      },
    ],
  },
];
